<template>
  <section class="section--pd section--pb-lg">
    <div class="inner Info__con">
      <div class="Info__head_area">
        <h2 class="Head Head--cl01 Head__main--tb">
          <span class="Head__main Head--md">Information</span><br>
          <span
            class="Head__main_jp"
          >お知らせ</span>
        </h2>
      </div>
      <div v-if="isLogin" class="Info__inner w-100">
        <div v-for="( item,key ) of listInformation" :key="key" class="Info__line ">
          <a
            class="Info__link"
            @click="readInfoLogin(item.info)"
          >
            <span :class="(item.status_read === 0) ? 'Info__link--new' : ''">
              {{ item.info.title }}
            </span>
          </a>
        </div>
      </div>
      <div v-else class="Info__inner w-100">
        <div v-for="( item,key ) of listInformation" :key="key" class="Info__line ">
          <a
            class="Info__link"
            @click="readInfo(item.id)"
          >
            <span :class="(isLogin && !item.status_read === 0) ? 'Info__link--new' : ''">
              {{ item.title }}
            </span>
          </a>
        </div>
      </div>
      <div class="Btn__area">
        <router-link
          class="Btn__line Btn__line--mgt-md Info__btn"
          to="/information"
        >
          お知らせ一覧へ
        </router-link>
      </div>
    </div>
  </section>
</template>
<script>
import informatioService from '@/services/informationService'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  data() {
    return {
      listInformation: [],
      newInfo: 0
    }
  },
  computed: {
    ...mapState({
      isLogin: state => state.user.isLogin
    })
  },
  created() {
    this.getListInformation()
  },
  methods: {
    async getListInformation() {
      this.$emit('updateLoadingInformation', true)
      const date = new Date()
      const today = moment(date).format('YYYY/MM/DD HH:mm:ss')
      if (this.isLogin) {
        const response = await informatioService.infoUser()
        const listInfo = response.data.data
        const result = []
        listInfo.forEach(element => {
          const date_send = moment(element.info.date).format('YYYY/MM/DD HH:mm:ss')
          if (element.info !== null && element.info.noti_flag === 0 && Date.parse(date_send) <= Date.parse(today)) {
            result.push(element)
          }
          if (element.info !== null && element.info.noti_flag === 1 && element.status_read === 1 && Date.parse(date_send) <= Date.parse(today)) {
            result.push(element)
          }
        })
        this.listInformation = result
      } else {
        const response = await informatioService.index()
        const listInfo = response.data.data
        console.log(listInfo)
        const result = []
        listInfo.forEach(element => {
          const date_send = moment(element.date).format('YYYY/MM/DD HH:mm:ss')
          if (Date.parse(date_send) <= Date.parse(today)) {
            result.push(element)
          }
        })
        this.listInformation = result
      }
      this.$emit('updateLoadingInformation', false)
    },
    async readInfo(id) {
      if (this.isLogin) {
        await informatioService.read(id)
      }
      window.location.href = id
    },
    async readInfoLogin(info) {
      if (this.isLogin) {
        await informatioService.read(info.id)
      }
      window.location.href = info.link
    }
  }
}
</script>
